/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../style/ourclinet.css';
import logo1 from '../images/gls.png'
import logo2 from '../images/nimra.jpeg'
import logo3 from '../images/HLCC.png'
import logo4 from '../images/PIMR.png'
import logo5 from '../images/inut.png'
import logo6 from '../images/JK Shah Logo.png'
import logo7 from '../images/LJ_University.png'
import logo8 from '../images/ICAI_logo.png'
import logo9 from '../images/loa.png'
const OurClients = () => {
    const settings = {
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1500,
        arrows: false,
        dots: false,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 520,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    };

    return (
        <>
            <section  id='cli'>
                <div className="container" style={{textAlign:'center'}}>
                    <h3 style={{marginTop:'25px', color:'rgb(13 92 126)'}}>As Featured In</h3>
                    <Slider {...settings} >
                        <div className="slide"><img src={logo1} width={'200px'} height={'200px'} alt='client'  /></div>
                        <div className="slide"><img src={logo2} width={'200px'} height={'200px'} alt='client' /></div>
                        <div className="slide"><img src={logo3} width={'200px'} height={'200px'} alt='client' /></div>
                        <div className="slide"><img src={logo4} width={'200px'} height={'200px'} alt='client' /></div>
                        <div className="slide"><img src={logo5} width={'200px'} height={'200px'} alt='client' /></div>
                        <div className="slide"><img src={logo6} width={'200px'} height={'200px'} alt='client' /></div>
                        <div className="slide"><img src={logo7} width={'200px'} height={'200px'} alt='client' /></div>
                        <div className="slide"><img src={logo8} width={'200px'} height={'200px'} alt='client' /></div>
                        <div className="slide"><img src={logo9} width={'200px'} height={'200px'} alt='client' /></div>
                    </Slider>
                </div>
            </section>
        </>
    );
};

export default OurClients;
